import { EditorView as e } from "@codemirror/view";
import { HighlightStyle as t, syntaxHighlighting as n } from "@codemirror/language";
import { tags as r } from "@lezer/highlight";
//#region src/tracking-code-input/editor-theme.ts
var i = e.theme({
	"&": {
		height: "100%",
		minHeight: "100%",
		fontSize: "14px",
		fontFamily: "inherit",
		color: "var(--color-text-primary)",
		backgroundColor: "var(--color-bg-primary)"
	},
	"&.cm-focused": { outline: "none" },
	".cm-scroller": {
		fontFamily: "inherit",
		lineHeight: "var(--tracking-code-row-height, 28px)",
		overflow: "auto"
	},
	".cm-content": {
		padding: "0",
		caretColor: "var(--color-text-primary)",
		minHeight: "100%"
	},
	".cm-line": {
		padding: "0 8px",
		minHeight: "var(--tracking-code-row-height, 28px)"
	},
	".cm-gutters": {
		backgroundColor: "var(--color-bg-secondary)",
		color: "var(--color-text-secondary)",
		border: "none",
		borderRight: "1px solid var(--color-field-border)",
		minWidth: "var(--tracking-code-gutter-width, 41px)",
		boxSizing: "border-box"
	},
	".cm-gutterElement": {
		lineHeight: "var(--tracking-code-row-height, 28px)",
		boxSizing: "border-box"
	},
	".cm-diagnosticGutter": {
		width: "24px",
		minWidth: "24px",
		overflow: "visible"
	},
	".cm-diagnosticGutter .cm-gutterElement": {
		width: "24px",
		padding: "0 0 0 8px",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		overflow: "visible"
	},
	".cm-lineNumbers": {
		fontVariantNumeric: "tabular-nums",
		fontFeatureSettings: "\"tnum\" 1"
	},
	".cm-lineNumbers .cm-gutterElement": {
		textAlign: "right",
		padding: "0 8px 0 4px",
		fontVariantNumeric: "tabular-nums",
		fontFeatureSettings: "\"tnum\" 1"
	},
	".cm-activeLine": { backgroundColor: "var(--color-bg-tertiary)" },
	".cm-activeLineGutter": {
		backgroundColor: "var(--color-bg-tertiary)",
		color: "var(--color-text-secondary)"
	},
	".cm-cursor, .cm-dropCursor": { borderLeftColor: "var(--color-text-primary)" },
	".cm-selectionLayer": {
		zIndex: "1 !important",
		pointerEvents: "none"
	},
	"&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground": { backgroundColor: "var(--color-alpha-color-alpha-color-20)" },
	".cm-content ::selection": { backgroundColor: "var(--color-alpha-color-alpha-color-20)" }
}, { dark: !1 }), a = t.define([
	{
		tag: r.tagName,
		color: "var(--color-system-blue-700)"
	},
	{
		tag: r.angleBracket,
		color: "var(--color-text-secondary)"
	},
	{
		tag: r.attributeName,
		color: "var(--color-system-teal-700)"
	},
	{
		tag: r.attributeValue,
		color: "var(--color-system-warning-700)"
	},
	{
		tag: r.string,
		color: "var(--color-system-warning-700)"
	},
	{
		tag: r.comment,
		color: "var(--color-text-tertiary)"
	},
	{
		tag: r.keyword,
		color: "var(--color-system-purple-700)"
	},
	{
		tag: r.number,
		color: "var(--color-system-teal-700)"
	},
	{
		tag: r.bool,
		color: "var(--color-system-purple-700)"
	},
	{
		tag: r.null,
		color: "var(--color-system-purple-700)"
	},
	{
		tag: r.propertyName,
		color: "var(--color-system-teal-700)"
	},
	{
		tag: r.variableName,
		color: "var(--color-text-primary)"
	},
	{
		tag: r.operator,
		color: "var(--color-text-secondary)"
	},
	{
		tag: r.punctuation,
		color: "var(--color-text-secondary)"
	},
	{
		tag: r.definition(r.variableName),
		color: "var(--color-text-primary)"
	},
	{
		tag: r.content,
		color: "var(--color-text-primary)"
	}
]), o = [i, n(a)];
//#endregion
export { o as trackingCodeEditorExtensions, i as trackingCodeEditorTheme, a as trackingCodeHighlightStyle };
